import React from "react";
import { useTranslation } from "react-i18next";
const SafeUserNameComponent = ({
  name
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("span", null, name ? name : t("Invited user"));
};
export { SafeUserNameComponent };